<template>
    <div>
        <h3>{{ formTitle }}</h3>
        <div class="large-form">
            <div class="form-line">
                <div class="form-field" id="form-field-page-type">
                    <label for="form-input-page-title">Page Type</label>
                    <div :class="'survey-new-page-type-intro pt-'+model.question_type+' pg-'+pageTypeNames[model.question_type].group">{{ pageTypeNames[model.question_type].name }}</div>
                </div>
            </div>
            
            <div class="form-line">
                <div class="form-field" id="form-field-page-title">
                    <label for="form-input-page-title">Page Name</label>
                    <input id="form-input-page-title" type="text" v-model="model.name" required>
                    <div class="field-note">Short name of this page <i>(for internal use only)</i>.</div>
                </div>
            </div>

            <div class="form-line">
                <div class="form-field" style="text-align: left" >
                    <label>Page Actions</label>
                    <div class="ws-button ws-button-secondary small" @click="duplicatePage">Duplicate Page</div>
                    <div class="ws-button ws-button-negative small" @click="deletePage">Delete Page</div>
                </div>
            </div>

            <div class="modal-errors">
                <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
            </div>
        </div>
        <div class="form-actions" >
            <div class="ws-button ws-button-secondary" @click="onCancel">Cancel</div>
            <div class="ws-button ws-button-main" @click="onSubmit">{{ buttonText }}</div>
        </div>
    </div>
</template>

<script>
import QuestionSettingsForm from "@/pages/surveys/QuestionSettingsForm";
import PageLogicForm from "@/pages/surveys/PageLogicForm";
import WSSelect from "@/components/elements/WSSelect.vue";

export default {
    name: 'PageSettingsForm',
    props: {
        page: {
            type: Object,
            default: () => ({
                name: undefined,
            })
        },
        storeName: {
            type: String,
            default: 'surveyPages'
        },
        formType: {
            type: String
        },
    },
    data() {
        return {
            pageType: null,
            errors: [],
            model: {
                name: undefined,
            },
            duplicate: undefined,

            pageTypeNames: {
                'opinion-scale': {
                    name: 'Opinion Scale',
                    group: 'rating',
                },
                'rating': {
                    name: 'Rating',
                    group: 'rating',
                },
                'ranking': {
                    name: 'Ranking',
                    group: 'rating',
                },
                'email': {
                    name: 'Email',
                    group: 'text',
                },
                'phone-number': {
                    name: 'Phone Number',
                    group: 'text',
                },
                'website': {
                    name: 'Website',
                    group: 'text',
                },
                'short-text': {
                    name: 'Short Text',
                    group: 'text',
                },
                'long-text': {
                    name: 'Long Text',
                    group: 'text',
                },
                'number': {
                    name: 'Number',
                    group: 'text',
                },
                'single-choice': {
                    name: 'Single Choice',
                    group: 'choice',
                },
                'multiple-choice': {
                    name: 'Multiple Choice',
                    group: 'choice',
                },
                'boolean': {
                    name: 'Yes / No Question',
                    group: 'choice',
                },
                'date': {
                    name: 'Date / Date Range',
                    group: 'choice',
                },
                'welcome': {
                    name: 'Welcome Page',
                    group: 'context',
                },
                'context': {
                    name: 'Welcome Page',
                    group: 'context',
                },
                'final': {
                    name: 'Welcome Page',
                    group: 'context',
                },
            },
        }
    },
    computed: {
        formTitle() {
            return (this.formType === 'create') ? 'Add New Survey Page' : 'Survey Page Settings';
        },
        buttonText() {
            return (this.formType === 'create') ? 'Add' : 'Save';
        }
    },
    created() {
        this.resetModel()
    },
    methods: {
        deletePage() {
            this.$emit('delete', this.model.id);
            this.resetModel();
        },
        duplicatePage() {
            this.duplicate = this.model;
            this.duplicate.id = undefined;
            this.duplicate.order = undefined;
            this.duplicate.created_at = undefined;
            
            if (this.duplicate.questions.length) {
                this.duplicate.question = this.duplicate.questions[0];
                this.duplicate.questions = undefined;
                this.duplicate.question.id = undefined;
                this.duplicate.question.order = undefined;
                this.duplicate.question.created_at = undefined;
            }
            
            this.$emit('duplicate', this.duplicate);
            this.resetModel();
        },
        onSubmit() {
            let fieldsToValidate = [{ name: 'Page Name', value: this.model.name, rules: ['required'] }];
            this.errors = this.validateFields(fieldsToValidate);
            if (Object.keys(this.errors).length) return;
            this.$emit('save', this.model);
            this.resetModel();
        },
        onCancel() {
            this.$emit('close');
            this.resetModel();
        },
        resetModel() {
            this.model = { ...this.page };
        },
    },
}
</script>
